import {Divider, Link, Typography} from '@genestack/ui';
import React from 'react';

import styles from './api-access.module.css';

interface Props {
    clientId: string;
}

export function UsageGuide({clientId}: Props) {
    const baseUrl = window.location.origin;

    return (
        <details>
            <summary className={styles.summary}>
                <Typography as="span" intent="quiet">
                    How to use
                </Typography>
            </summary>

            <Divider variant="transparent" />

            <Typography intent="quiet">Get a token (expires in 1 hour):</Typography>
            <Divider variant="transparent" />
            <div className={styles.codeBlock}>
                {`curl -X POST ${baseUrl}/oauth2/token \\
  -u "${clientId}:<client_secret>" \\
  -d grant_type=client_credentials \\
  -d scope=api

# {"access_token":"eyJhbG...","token_type":"bearer","expires_in":3600}`}
            </div>

            <Divider variant="transparent" />

            <Typography intent="quiet">
                Call the API with the token, for example search published documents by name:
            </Typography>
            <Divider variant="transparent" />
            <div className={styles.codeBlock}>
                {`curl -X POST ${baseUrl}/api/documents/v1/search \\
  -H "Authorization: Bearer eyJhbG..." \\
  -H "Content-Type: application/json" \\
  -d '{"stringSearch": {"value": "insulin"}, "statuses": ["PUBLISHED"], "limit": 10}'`}
            </div>

            <Divider variant="transparent" />

            <Typography intent="quiet">
                All operations are described in the{' '}
                <Link href="/api/docs" target="_blank">
                    public API docs
                </Link>
                .
            </Typography>
        </details>
    );
}
